module.exports = __webpack_public_path__ + "media/newstyle/images/icon-search-purple-77644edee80c7ad9a549445e9cf98f4a.svg";